/**
 * Private modules
 */
const {
  accountId,
  address,
  alias,
  createQueryComponent,
  isSelected,
  objectId,
  objectIds,
  pin,
  receiptFormat,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createAccountPrinter: {
    properties: {
      body: {
        properties: {
          address,
          alias,
          receiptFormat,
        },
        required: [
          'address',
          'alias',
          'receiptFormat',
        ],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteAccountPrinters: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getAccountPrinters: {
    properties: {
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateAccountPrinterById: {
    properties: {
      body: {
        properties: {
          address,
          alias,
          isSelected,
          pin,
          receiptFormat,
        },
        required: [
          'address',
          'alias',
          'isSelected',
          'pin',
          'receiptFormat',
        ],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
          objectId,
        },
        required: [
          'accountId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
